const methods = {
  POST: "post",
  GET: "get",
  PUT: "put",
}

const CarDomain = '/csp/temporaryparkingrecord'

const Apis = {
  CreateOrder: {
    uri: `/apis${CarDomain}/createOrder`,
    method: methods.POST
  },
  ConfirmOrder: {
    uri: `/apis${CarDomain}/pay`,
    method: methods.POST
  },
  NotifyOrder: {
    uri: `/apis${CarDomain}/notifyOrder`,
    method: methods.PUT
  },
  PayOrder: {
    uri: `/apis/pay/payreceivables/qr-code/inner/create`,
    method: methods.POST
  },
  Visitor: {
    uri: `/apis/csp/cspVisitorRegister/visitor/noPermission/accessControlSelfAuthorizationDetailsRecord/`,
    method: methods.GET
  },
  Register: {
    uri: `/apis/pms/equipmentparameter/getDeviceLocation`,
    method: methods.POST
  },
  Invite: {
    uri: `/apis/public/intentional/save`,
    method: methods.POST
  },
  Registration: {
    uri: `/apis/pms/personnelregistration/addPersonnelRegistrationByCode`,
    method: methods.POST
  },
  ImageUpload: {
    uri: `/apis/admin/file/public/upload`,
    method: methods.POST
  },
  Carsarchiv: {
    uri: `/apis/pms/vehicleregistration/saveByQrCode`,
    method: methods.POST
  },
  GetBanners: {
    uri: `/operApi/operation/operationManager/queryOperationContent`,
    method: methods.GET
  },
  AddClickRate: {
    uri: '/operApi/operation//operationManager/addClickRate/',
    method: methods.POST
  },
  OpenDoor: {
    uri: '/apis/csp/cspVisitorConfig/visitor/open/',
    method: methods.GET
  },
  CheckDoorStatus: {
    uri: '/apis/csp/openrecord/tuYaOperation/noPermission/openStateBySn/',
    method: methods.GET
  },
  OpenStateBySn: {
    uri: '/apis/csp/openrecord/tuYaOperation/openStateBySn/',
    method: methods.GET
  },
  queryMonthlyCardInformation: {
    uri: '/apis/csp/cspMcardMange/noPermission/queryMonthlyCardInformation',
    method: methods.POST
  },
  deferredPaymentOfMonthlyCard: {
    uri: '/apis/pay/payreceivables/qr-code/inner/create/deferredPaymentOfMonthlyCard',     //月卡临停支付 
    method: methods.POST
  },
  cacheOrders: {
    uri: '/apis/pay/payreceivables/noPermission/cacheOrders',    //月卡临停支付缓存订单
    method: methods.POST
  },
  accountsReceivableAppPaymentForm: {
    uri: '/apis/pay/payreceivables/accountsReceivableAppPaymentForm',
    method: methods.POST
  },
  // 获取订单号
  queryOrderId: {
    uri: '/apis/pay/payreceivables/noPermission/redis',
    method: methods.POST
  },
  // 支付
  lakalAppPay: {
    uri: '/apis/pay/payreceivables/paymentNotice/noPermission/lakalAppPay',
    method: methods.POST
  },
  // 查询支付状态
  getpayStatus: {
    uri: '/apis/pay/payreceivables/inner/noPermission/getpayStatus',
    method: methods.POST
  },
  // 收银台支付
  QRCodePay: {
    uri: '/apis/pay/payreceivables/QRCodePay',
    method: methods.POST
  },
  getQuestionnaire: {
    uri: '/apis/csp/cspQuestionRelease/open/detail/',
    method: methods.GET
  },
  saveQuestionnaire: {
    uri: '/apis/csp/cspQuestionRecord/open/submit',
    method: methods.POST
  },
}

export default Apis